export function getCookieDomain(): string {
  const domain = import.meta.env?.VITE_COOKIE_DOMAIN;
  if (!domain) {
    throw new Error("VITE_COOKIE_DOMAIN is not defined.");
  }
  return domain;
}

/**
 * Domínio a usar no atributo `domain`: o configurado, quando o host atual pertence a ele (o
 * cookie é compartilhado entre os subdomínios). Em outro host — localhost com o `.env` de
 * staging, por exemplo — o navegador recusaria o cookie e a sessão nunca seria salva, então
 * o cookie fica só no host atual.
 */
export function resolveCookieDomain(domain: string | undefined): string | undefined {
  if (!domain) return undefined;
  const cleanDomain = domain.replace(/^\./, "").toLowerCase();
  const host = typeof window !== "undefined" ? window.location.hostname.toLowerCase() : "";
  if (cleanDomain === "localhost") return undefined;
  return host === cleanDomain || host.endsWith(`.${cleanDomain}`) ? domain : undefined;
}

export function getCookie(name: string): string | null {
  if (typeof document === "undefined" || !document.cookie) return null;

  const cookies = document.cookie.split(";");
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i].trim();
    if (!cookie) continue;
    const eqIndex = cookie.indexOf("=");
    const key = eqIndex === -1 ? cookie : cookie.slice(0, eqIndex);
    if (key === name) {
      const val = eqIndex === -1 ? "" : cookie.slice(eqIndex + 1);
      try {
        return decodeURIComponent(val);
      } catch {
        return val;
      }
    }
  }

  return null;
}

export function setCookie(name: string, value: string, days = 7): void {
  if (typeof document === "undefined") return;

  const maxAge = days * 24 * 60 * 60;
  const domain = resolveCookieDomain(getCookieDomain());
  const domainPart = domain ? `; domain=${domain}` : "";
  const securePart = typeof window !== "undefined" && window.location.protocol === "https:" ? "; Secure" : "";

  document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}; path=/; max-age=${maxAge}; SameSite=Lax${domainPart}${securePart}`;
}

export function deleteCookie(name: string): void {
  if (typeof document === "undefined") return;

  let domain = "";
  try {
    domain = getCookieDomain();
  } catch {
    //
  }

  const cleanDomain = domain.replace(/^\./, "").toLowerCase();
  const domainPart = !domain || cleanDomain === "localhost" ? "" : `; domain=${domain}`;
  const securePart = typeof window !== "undefined" && window.location.protocol === "https:" ? "; Secure" : "";

  if (domainPart) {
    document.cookie = `${encodeURIComponent(name)}=; path=/; max-age=0; SameSite=Lax${domainPart}${securePart}`;
  }
  document.cookie = `${encodeURIComponent(name)}=; path=/; max-age=0; SameSite=Lax${securePart}`;
}
